class wcProductForm extends HTMLElement {
  constructor() {
    super();
    if (!this) return;
    this.wcProductWrapper = this.closest('.product--waldencast');
    this.wcStickyAtc = document.querySelector('wc-sticky-atc');
    this.drawerAdjacentProductsContainer = document.querySelector('div[data-adjacent-products-container]');
    this.wcAdjecentProductsHandle = this.dataset.wcAdjecentProductsHandle;
    this.wcHasAdjecentProducts = this.wcAdjecentProductsHandle != '';
    this.wcOutOfStock = this.dataset.wcOutOfStock;

    this.wcAdjecentProductsOrderCollection = this.wcAdjecentProductsHandle.replace('--', '').replaceAll(' ', '-').toLowerCase();

    if (this.wcHasAdjecentProducts) {
      this.adjacentProductsContainer = this.querySelector('[data-wc-adjacent-products-container]');
      this.getAdjecentProducts();
    }
    this.productOptions = [...this.querySelectorAll('[data-wc-product-option]')];
    this.currentOptionIndex = 0;
    this.watchProductOptions();
    if (this.wcStickyAtc) this.initStickyAtc();
    this.watchAppContainer();
    this.wcProductInfoContainer = this.closest('.product__info-container');
    this.wcPriceWrapper =  this.wcProductInfoContainer.querySelector('.product__price__wrapper');
    this.titleOption = this.wcProductInfoContainer.querySelector('[data-wc-title-option]');
    this.restoreScrollPosition();
  }

  restoreScrollPosition() {
    const pdpScrollY = parseInt(localStorage.getItem('pdp-scroll-y'));
    if (pdpScrollY) {
      document.documentElement.scrollTop = pdpScrollY;
      localStorage.removeItem('pdp-scroll-y');
    }
  }

  async getAdjecentProducts () {

    var html = ''
    var useSearch = false;

    await fetch(`${window.shopUrl}/collections/${this.wcAdjecentProductsOrderCollection}/?view=wc-adjacent-products`)
    .then(response => response.text())
    .then((responseText) => {
        html = new DOMParser().parseFromString(responseText, 'text/html')
        var noCollection = html.querySelector('.template-404');
        if(noCollection){
          useSearch = true;
          return;
        }else{
        this.adjacentProductsContainer.innerHTML = html?.querySelector('.wc-adjecent-products').outerHTML;
        this.adjacentProducts = [...this.querySelectorAll('.wc-adjecent-product')];
        if (this.wcStickyAtc) {
          this.stickyAdjacentProductsContainer.innerHTML = html.querySelector('.wc-adjecent-products').outerHTML;
          this.stickyAdjacentProducts = this.stickyAdjacentProductsContainer.querySelectorAll('.wc-adjecent-product');
        }
        if (this.drawerAdjacentProductsContainer) {
          this.drawerAdjacentProductsContainer.innerHTML = html.querySelector('.wc-adjecent-products').outerHTML;
          this.drawerAdjacentProducts = this.drawerAdjacentProductsContainer.querySelectorAll('.wc-adjecent-product');
          this.initDrawAdjacentProducts();
        }
      }

    })
    .catch(error => {
      console.log(error);
    })


    if(useSearch){
      const searchAdjecentProductsUrl = `/search?view=wc-adjacent-products&q=${this.wcAdjecentProductsHandle}&options%5Bprefix%5D=none&type=product`;  
      try {
        const adjecentProductsHtml = await fetch(searchAdjecentProductsUrl);
        const adjecentProductsHtmlText = await adjecentProductsHtml.text();
        this.adjacentProductsContainer.innerHTML = adjecentProductsHtmlText;
        this.adjacentProducts = [...this.adjacentProductsContainer.querySelectorAll('.wc-adjecent-product')];
        if (this.wcStickyAtc) {
          this.stickyAdjacentProductsContainer.innerHTML = adjecentProductsHtmlText;
          this.stickyAdjacentProducts = this.stickyAdjacentProductsContainer.querySelectorAll('.wc-adjecent-product');
        }
        if (this.drawerAdjacentProductsContainer) {
          this.drawerAdjacentProductsContainer.innerHTML = adjecentProductsHtmlText;
          this.drawerAdjacentProducts = this.drawerAdjacentProductsContainer.querySelectorAll('.wc-adjecent-product');
          this.initDrawAdjacentProducts();
        }
      } catch (error) {
        console.warn('Error finding product', error);
      }
    }

    this.adjecentProductsContainer = this.querySelector('[data-wc-adjecent-product-handles]');
    this.adjecentProducts = this.querySelectorAll('.wc-adjecent-product');
    this.updateSelectedProduct(this.adjecentProducts);
    if (this.wcStickyAtc) this.updateSelectedProduct(this.stickyAdjacentProducts);
    if (this.drawerAdjacentProductsContainer) this.updateSelectedProduct(this.drawerAdjacentProducts);
  };

  updateSelectedProduct(adjecentProducts) {
    adjecentProducts.forEach(adjecentProduct => {
      if (adjecentProduct.dataset.wcProductId === this.dataset.wcProductId) {
        adjecentProduct.classList.add('wc-selected');
      } else {
        adjecentProduct.classList.remove('wc-selected');
      }
    });
  }

  changeCurrentOption(productOption, changeType) {
    const optionIndex = this.productOptions.indexOf(productOption);
    let targetOptionIndex = optionIndex;
    if (changeType == 'next') {
      targetOptionIndex++;
    } else if (changeType === 'previous') {
      targetOptionIndex--;
    }
    this.productOptions.forEach((option, index) => {
      if (index === targetOptionIndex) {
        option.classList.add('wc-current-step');
        option.ariaCurrent = "step";
      } else {
        option.classList.remove('wc-current-step');
        option.removeAttribute('aria-current');
      }
    });
    this.currentOptionIndex = targetOptionIndex;
    if (targetOptionIndex + 1 === this.productOptions.length) {
      this.activateSubmitButton();
      this.classList.add('wc-last-step');
    } else {
      this.classList.remove('wc-last-step');
    }
  }

  activateSubmitButton() {
    this.querySelector('[data-wc-submit-button]').classList.remove('button--secondary');
    if (this.wcStickyAtc) { 
      this.wcStickyAtc.querySelector('.button--atc-mobile').classList.remove('button--secondary');
      this.wcStickyAtc.querySelector('wc-sticky-atc-form').dataset.wcSelect = "false";
    }
    this.dataset.wcSubmitActive = 'true';
    this.wcPriceWrapper.classList.remove('wc-show-from-price');
    if (this.stickyAtcButtons) {
      this.stickyAtcButtons.forEach(button => button.dataset.wcSelect = false);
    }
    console.log(this.wcStickyAtc);
    console.log(this.stickyAtcButtons);
  }

  handleOptionLabelClick(optionLabel) {
    if (this.titleOption) {
      if (this.titleOption.dataset.wcTitleOption === optionLabel.dataset.wcOptionName) {
        this.titleOption.textContent = optionLabel.querySelector('[data-wc-option-title]').textContent;
      }
    }
    if (optionLabel.closest('[data-wc-product-option="variant"]')) this.changeCurrentOption(optionLabel.closest('.wc-product-option'));
  }

  watchProductOptions() {
    const handleStepButton = (productOption) => {
      productOption.addEventListener('click', event => {
        if (event.target.closest('[data-wc-step-button]')) {
          this.changeCurrentOption(productOption, 'next');
        } else if (event.target.closest('[data-wc-accordion-trigger]')) {
          this.changeCurrentOption(productOption, 'current');
        }
      })
    }
    this.productOptions.forEach(productOption => {
      handleStepButton(productOption);
    });
    const productOptionLabels = this.querySelectorAll('.wc-product-option');
    productOptionLabels.forEach(label => {
      label.addEventListener('click', (event) => this.handleOptionLabelClick(event.currentTarget));
    })
  }

  initStickyAtc() {
    this.wcStickyAtc = document.querySelector('wc-sticky-atc');
    this.stickyAdjacentProductsContainer = this.wcStickyAtc.querySelector('[data-wc-sticky-atc-adjacent-products-container]');
    this.stickyAtcButtons = this.wcStickyAtc.querySelectorAll('[data-wc-sticky-atc-button]');
  }

  setActiveAdjacentProduct(clickedProductId, adjacentProducts) {
    adjacentProducts.forEach(ajacentProduct => {
      if (ajacentProduct.dataset.wcProductId === clickedProductId) {
        ajacentProduct.classList.add('wc-selected');
      } else {
        ajacentProduct.classList.remove('wc-selected');
      }
    });
  }

  initDrawAdjacentProducts() {
    const drawerDetails = this.drawerAdjacentProductsContainer.closest('.wc-menu-drawer__disclosure');
    this.drawerAdjacentProductsContainer.addEventListener('click', event => {
      const clickedProduct = event.target.closest('wc-adjecent-product');
      if (clickedProduct) {
        const clickedProductId = clickedProduct.dataset.wcProductId;
        [this.adjacentProducts, this.stickyAdjacentProducts, this.drawerAdjacentProducts].forEach(adjacentProducts => {
          this.setActiveAdjacentProduct(clickedProductId, adjacentProducts)
        });
        this.adjacentProducts.find(product => product.dataset.wcProductId === clickedProductId).click();
        drawerDetails.querySelector('.wc-menu-drawer__close').click();
      }
    });
  }

  handleRechargeVariantClick(rechargeDisabled) {
    if (this.appsContainer.querySelector('.rc-widget')) {
      this.dataset.wcRechargeDisabled = rechargeDisabled;
      if (this.wcStickyAtc) this.wcStickyAtc.dataset.wcRechargeDisabled = rechargeDisabled;
      const singlePurchaseButton = this.appsContainer.querySelector('.rc-widget .onetime-radio');
      singlePurchaseButton.click();
    }
  }

  watchAppContainer() {
    this.appsContainer = this.querySelector('[wc-pdp-apps]');
    if (this.appsContainer) {
      const stickyAtcVariants = this.wcStickyAtc.querySelectorAll('[data-wc-recharge-disabled]');
      this.rechargeVariants = [...stickyAtcVariants,...this.querySelectorAll('[data-wc-recharge-disabled]')];
      this.rechargeVariants.forEach(varient => {
        varient.addEventListener('click', () => this.handleRechargeVariantClick(varient.dataset.wcRechargeDisabled));
      });
    }
  }
}

window.customElements.define('wc-product-form', wcProductForm);